/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AdOperatorReportIoQueryVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type AdOperatorReportIoQuery = {
  __typename?: 'Query'
  vehicle: {
    __typename?: 'Vehicle'
    id: string
    fccUpcomingWaypoints: Array<{
      __typename?: 'FccWaypoint'
      id: string
      actions: Array<
        | {
            __typename: 'FccWaypointDeliveryAction'
            id: string
            trip: { __typename?: 'Trip'; id: string } | null
          }
        | { __typename?: 'FccWaypointHubReturnAction' }
        | {
            __typename: 'FccWaypointPickupAction'
            id: string
            trip: { __typename?: 'Trip'; id: string } | null
          }
        | { __typename?: 'FccWaypointReallocationAction' }
      >
    }> | null
  }
}

export type AdOperatorReportIoWaypointFragment = {
  __typename?: 'FccWaypoint'
  id: string
  actions: Array<
    | {
        __typename: 'FccWaypointDeliveryAction'
        id: string
        trip: { __typename?: 'Trip'; id: string } | null
      }
    | { __typename?: 'FccWaypointHubReturnAction' }
    | {
        __typename: 'FccWaypointPickupAction'
        id: string
        trip: { __typename?: 'Trip'; id: string } | null
      }
    | { __typename?: 'FccWaypointReallocationAction' }
  >
}

export type AdOperatorReportIoPickupActionFragment = {
  __typename: 'FccWaypointPickupAction'
  id: string
  trip: { __typename?: 'Trip'; id: string } | null
}

export type AdOperatorReportIoDeliveryActionFragment = {
  __typename: 'FccWaypointDeliveryAction'
  id: string
  trip: { __typename?: 'Trip'; id: string } | null
}

export const AdOperatorReportIoPickupActionFragmentDoc = gql`
    fragment AdOperatorReportIoPickupAction on FccWaypointPickupAction {
  __typename
  id
  trip {
    id
  }
}
    `
export const AdOperatorReportIoDeliveryActionFragmentDoc = gql`
    fragment AdOperatorReportIoDeliveryAction on FccWaypointDeliveryAction {
  __typename
  id
  trip {
    id
  }
}
    `
export const AdOperatorReportIoWaypointFragmentDoc = gql`
    fragment AdOperatorReportIoWaypoint on FccWaypoint {
  id
  actions {
    ... on FccWaypointPickupAction {
      ...AdOperatorReportIoPickupAction
    }
    ... on FccWaypointDeliveryAction {
      ...AdOperatorReportIoDeliveryAction
    }
  }
}
    `
export const AdOperatorReportIoDocument = gql`
    query AdOperatorReportIo($vehicleId: ID!) {
  vehicle: vehicleByID(id: $vehicleId) {
    id
    fccUpcomingWaypoints {
      ...AdOperatorReportIoWaypoint
    }
  }
}
    ${AdOperatorReportIoWaypointFragmentDoc}
${AdOperatorReportIoPickupActionFragmentDoc}
${AdOperatorReportIoDeliveryActionFragmentDoc}`

/**
 * __useAdOperatorReportIoQuery__
 *
 * To run a query within a React component, call `useAdOperatorReportIoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdOperatorReportIoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdOperatorReportIoQuery({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAdOperatorReportIoQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdOperatorReportIoQuery,
    AdOperatorReportIoQueryVariables
  > &
    (
      | { variables: AdOperatorReportIoQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdOperatorReportIoQuery,
    AdOperatorReportIoQueryVariables
  >(AdOperatorReportIoDocument, options)
}
export function useAdOperatorReportIoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdOperatorReportIoQuery,
    AdOperatorReportIoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdOperatorReportIoQuery,
    AdOperatorReportIoQueryVariables
  >(AdOperatorReportIoDocument, options)
}
// @ts-ignore
export function useAdOperatorReportIoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdOperatorReportIoQuery,
    AdOperatorReportIoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdOperatorReportIoQuery,
  AdOperatorReportIoQueryVariables
>
export function useAdOperatorReportIoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdOperatorReportIoQuery,
        AdOperatorReportIoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdOperatorReportIoQuery | undefined,
  AdOperatorReportIoQueryVariables
>
export function useAdOperatorReportIoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdOperatorReportIoQuery,
        AdOperatorReportIoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AdOperatorReportIoQuery,
    AdOperatorReportIoQueryVariables
  >(AdOperatorReportIoDocument, options)
}
export type AdOperatorReportIoQueryHookResult = ReturnType<
  typeof useAdOperatorReportIoQuery
>
export type AdOperatorReportIoLazyQueryHookResult = ReturnType<
  typeof useAdOperatorReportIoLazyQuery
>
export type AdOperatorReportIoSuspenseQueryHookResult = ReturnType<
  typeof useAdOperatorReportIoSuspenseQuery
>
export type AdOperatorReportIoQueryResult = Apollo.QueryResult<
  AdOperatorReportIoQuery,
  AdOperatorReportIoQueryVariables
>
